import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-biller4',
  templateUrl: './biller4.component.html',
  styleUrls: ['./biller4.component.scss']
})
export class Biller4Component implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
